import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client"

import config from "../config"

export default () =>
  new ApolloClient({
    cache: new InMemoryCache({
      typePolicies: {},
    }),
    link: new HttpLink({
      headers: {
        authorization: `Bearer ${process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN}`,
      },
      uri: config.GATSBY_CONTENTFUL_GRAPHQL_ENDPOINT,
    }),
  })
